import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Block from './Block';
import Grid from './Grid';
import Cell from './Cell';
import H2 from './H2';
import RichTextHtml from './RichTextHtml';
import SubscribeNewsletterInput from './SubscribeNewsletterInput';

const PageSubscribeNewsletter = ({ content }) => (
  <Block id={content.internal_link_id} backgroundColor="grayLight">
    <Grid halign="center">
      <Cell
        size={{ mobile: 1, tablet: 3 / 5 }}
        px="baseUnit"
        py={{ mobile: 'baseUp8', tablet: 'baseUp12' }}
      >
        <H2 textAlign="center" pb={{ mobile: 'baseUnit', tablet: 'baseUp4' }}>
          {content.title1.text}
        </H2>

        <RichTextHtml
          html={content.text.html}
          pb={{ mobile: 'baseUp2', tablet: 'baseUp8' }}
          px={{ tablet: 'baseUp4' }}
          mb="0"
          textAlign={{ tablet: 'center' }}
        />

        <SubscribeNewsletterInput
          content={{
            success: content.input_field.document.data.success_message,
            error: content.input_field.document.data.error_message,
            invalid: content.input_field.document.data.invalid_message,
            required: content.input_field.document.data.required_message,
            placeholder: content.input_field.document.data.input_placeholder,
          }}
        />
      </Cell>
    </Grid>
  </Block>
);

PageSubscribeNewsletter.propTypes = {
  content: PropTypes.shape({
    internal_link_id: PropTypes.string,
    title1: PropTypes.shape({
      text: PropTypes.string,
    }).isRequired,
    text: PropTypes.shape({
      html: PropTypes.string,
    }).isRequired,
    disclaimer: PropTypes.shape({
      html: PropTypes.string,
    }),
    input_field: PropTypes.shape({
      document: PropTypes.shape({
        data: PropTypes.shape({
          error_message: PropTypes.string,
          input_placeholder: PropTypes.string,
          invalid_message: PropTypes.string,
          required_message: PropTypes.string,
          success_message: PropTypes.string,
        }),
      }),
    }).isRequired,
  }).isRequired,
};

export default PageSubscribeNewsletter;

export const query = graphql`
  fragment PageSubscribeNewsletterFragment on PrismicPageDataBodySubscibeNewsletter {
    id
    slice_type
    primary {
      internal_link_id
      title1 {
        text
      }
      text {
        html
      }
      disclaimer {
        html
      }
      input_field {
        document {
          ... on PrismicNewsletterSubscribeInput {
            data {
              error_message
              input_placeholder
              invalid_message
              required_message
              success_message
            }
          }
        }
      }
    }
  }
`;
